import React from 'react';
import { Space, Breadcrumb, Button, Tooltip, Table } from 'antd';
import { CardLayout } from 'components/molecules';
import { useB2cStudent } from 'hooks';
import LectureInfoForm from '../../components/lectureInfo'
import StudentList from '../../components/studentTable'
import { usePopupManager } from 'react-popup-manager';
import { ColumnsType } from 'antd/lib/table/interface';
import { StudentEditModal, CompanyEditModal } from 'components/molecules';
import { CarryOutOutlined, DeleteOutlined } from '@ant-design/icons'

export interface  LectureProps {}

const  LectureStudent = ({}:  LectureProps): React.ReactElement => {
  /* ======================================================
   * hooks
   * ====================================================== */
  const { lectureInfo, studentList, delList, refetch, memoUpdate } = useB2cStudent();  
 

  /* ======================================================
   * variables
   * ====================================================== */
  const { open } = usePopupManager();

  const columns: ColumnsType<StudentListDto> = [
    {
      title: '번호',
      key: 'num',
      width: '50px',
      align: 'center',
      render: (text, record, index) => {
        return (
          index+1
        )
      }        
    },  
    {
      title: '상태',
      key: 'status',
      width: '80px',
      align: 'center',
      render: (text, record, index) => {
        return (
          record.delete_yn==='Y'?record.history_memo?'취소':'삭제':'연기'
        )
      }        
    },     
    {
      title: '변경일',
      key: 'update_at',
      dataIndex: 'update_at',
      width: '120px',
      align: 'center',
    },       
    {
      title: '회사명',
      dataIndex: 'company_name',
      key: 'company_name',
      width: '150px',
      align: 'center', 
      ellipsis: true,   
      render: (company_name, record) => {
        return record.company_srl?
          <a onClick={(e) => {
            e.stopPropagation();
            open(CompanyEditModal, {
              id: record.company_srl,
              isPopup: true,
              onClose: (isOk) => {if(isOk) refetch();},
            }); 
          }}>
            <label>{company_name}</label>
          </a>:<label style={{color:'red'}}>{company_name}</label>        
      }          
    },  
    {
      title: '부서명',
      dataIndex: 'department',
      key: 'department',
      width: '150px',
      align: 'center',
      ellipsis: true,
    },
    {
      title: '이름',
      dataIndex: 'name_kor',
      key: 'name_kor',
      width: '120px',
      align: 'center',
      ellipsis: true,  
      render: (name_kor, record) => {
        return (
          (record.app_memo)?(
            <Tooltip placement="topLeft" title={record.app_memo}>
              <CarryOutOutlined />&nbsp;<label style={{color:'#1890ff'}}>{name_kor}</label>
            </Tooltip>
          ):(<label style={{color:'#1890ff'}}>{name_kor}</label>)
        )
      },
      onCell: (record) => {
        return {
            onClick: (e) => {
              open(StudentEditModal, { 
                id: record.id,
                group: 'lecture',
                lectureInfo: lectureInfo,
                onClose: (isOk) => {
                  if (isOk) {   
                    refetch();
                  };
                },          
              }); 
            },
        };
      },
    },   
    {
      title: '휴대폰',
      dataIndex: 'phone',
      key: 'phone',
      width: '100px',
      align: 'center',
      ellipsis: true,     
    },    
    {
     title: '이메일',
     dataIndex: 'email',
     key: 'email',
     width: '200px',
     align: 'center',
     ellipsis: true,     
   },

 {
  title: '사유',
  dataIndex: 'history_memo',
  key: 'history_memo',
  width: 'auto',
  align: 'left',
  ellipsis: true, 
  render: (history_memo, record) => {
    return (
      (history_memo)?(history_memo): ('담당자 삭제')
    )
  }  
},     
  ];

  /* ======================================================
   * events
   * ====================================================== */    

  /* ======================================================
   * hooks
   * ====================================================== */

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <CardLayout title={(
      <Breadcrumb>
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>B2C</Breadcrumb.Item>
        <Breadcrumb.Item>공개과정</Breadcrumb.Item>
        <Breadcrumb.Item>{lectureInfo?.lecture_title}</Breadcrumb.Item>
        <Breadcrumb.Item>교육생정보</Breadcrumb.Item>
    </Breadcrumb>      
    )}>
       <Space direction="vertical" style={{ width: '100%' }}>
          <LectureInfoForm info={lectureInfo} type='lecture' onMemoUpdate={memoUpdate} />
          <StudentList info={lectureInfo} group={'lecture'} studentList={studentList} refetch={refetch} />
          <div style={{ marginTop: 20 }}>
          <h4><DeleteOutlined />&nbsp;변경 목록</h4>
          </div>
          <Table
            tableLayout="fixed"
            dataSource={delList}
            columns={columns}
            pagination={false}
            style={{ width: '100%', overflowX: 'auto', minWidth: 600 }}
            className="columnCenterFixTable clickable"
            showSorterTooltip={false}
            rowKey={'id'}
          />
       </Space>                  
    </CardLayout>
  )
};

export default  LectureStudent;    